module.exports = __webpack_public_path__ + "img/mini-017.c0e8cbc0.jpg";